import { CoreButton } from '@featuring-corp/components';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import InfluencerTable, {
	InfluencerTableProps,
} from '@components/report/influencer-table/InfluencerTable';

import { containerClass } from './style.css';

export type SimilarGroupNbProps<T extends string[]> = InfluencerTableProps<T>;

const SimilarGroupNb = <T extends string[]>(props: SimilarGroupNbProps<T>) => {
	const { t } = useTranslation('infReportInstagram');
	const available = !props.isLoading && !props.isError && !props.lackOfPermission;
	const [viewableSize, setViewableSize] = useState(5);

	const data = props.data ? props.data.slice(0, viewableSize) : [];

	return (
		<div className={containerClass}>
			<InfluencerTable header={['일 방문자', '누적 방문자']} {...props} data={data} />
			{available && props.data?.length > viewableSize && (
				<CoreButton
					buttonType="tertiary"
					size="sm"
					// text={t('features.report.section-content.ig.similar-group.influencer-table.button')}
					text={'더 보기'}
					onClick={() => setViewableSize(viewableSize + 5)}
				/>
			)}
		</div>
	);
};

export default SimilarGroupNb;
